export enum tripSaleConstants {
  GET_TRIP_SALES = 'GET_TRIP_SALES',
}
